// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".didomi-popup-close {\n\tdisplay: none;\n}\n", "",{"version":3,"sources":["webpack://./app/components/static_pages/cookies_management.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd","sourcesContent":[".didomi-popup-close {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
